import useAppRoutes from '@fingo/lib/hooks/useAppRoutes';
import useGetCountryFromUrl from '@fingo/lib/hooks/useGetCountryFromUrl';
import useGetUser from '@fingo/lib/hooks/useGetUser';
import useIsMobile from '@fingo/lib/hooks/useIsMobile';
import { useMemo } from 'react';
import {
  analyticsRoutes,
  homeRoutes,
  termsRoutes,
  notificationsRoutes,
  profileRoutes,
  purchasesRoutes,
  salesRoutes,
  supplierAutomateRoutes,
} from '../routes';

const useWorkspaceRoutes = () => {
  const currentUser = useGetUser();
  const country = useGetCountryFromUrl();
  const selectedCompany = useMemo(() => currentUser?.selectedCompany, [currentUser]);
  const isMobile = useIsMobile();

  const context = useMemo(
    () => ({
      country,
      selectedCompany,
      isMobile,
    }),
    [country, selectedCompany, isMobile],
  );

  const routeProviders = useMemo(
    () => [
      () => analyticsRoutes(),
      () => homeRoutes(),
      () => termsRoutes(),
      () => notificationsRoutes(),
      () => profileRoutes(),
      () => purchasesRoutes(),
      () => salesRoutes(),
      () => supplierAutomateRoutes(),
    ],
    [],
  );

  return useAppRoutes({
    user: currentUser,
    routeProviders,
    context,
  });
};

export default useWorkspaceRoutes;
